import PropTypes from 'prop-types';
import type * as React from 'react';
import type { Status } from '../../../../common/models/popup-alert';
import AriaLabel from './../../AriaHelper/AriaLabel';
import style from './style.m.less';

interface Props {
    children?: React.ReactNode;
    status?: Status;
}

export default function PopupAlertStatus({ status, children }: Props) {
    if (!status) {
        return <>{children}</>;
    }

    let c, label;
    if (status === 'success') {
        c = style.success;
        label = 'Success: ';
    } else if (status === 'error') {
        c = style.error;
        label = 'Error: ';
    } else {
        c = style.info;
        label = 'Info: ';
    }

    return (
        <div className={c}>
            <AriaLabel>{label}</AriaLabel>
            {children}
        </div>
    );
}

PopupAlertStatus.propTypes = {
    children: PropTypes.node.isRequired,
    status: PropTypes.oneOf(['info', 'success', 'error']),
};
